module.exports = __webpack_public_path__ + "img/map-sa.24ea1db3.png";